import React, { useEffect, useState } from "react";
import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { Dash, Plus, Trash } from "react-bootstrap-icons";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function AddEventAccess({ cancelModal, productId, clubId }) {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState("");
  const { user } = useAuthContext();
  const [addedEvents, setAddedEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  //styled

  const handleRemove = async (addedEvent) => {
    setIsLoading(true); // Start loading
    try {
      await axios.delete(
        `${ApiConnectionString}/api/productaccess/${productId}/${addedEvent.id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      // After successful deletion, fetch events
      await fetchEvents();
    } catch (error) {
      console.error("Error removing event:", error);
      // Optionally, you can display an error message to the user here
    } finally {
      setIsLoading(false); // Reset the loading state after the request is complete
    }
  };

  const fetchEvents = async () => {
    setIsLoading(true);
    try {
      const addedEventsResponse = await axios.get(
        `${ApiConnectionString}/api/curentAccess/${productId}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (addedEventsResponse.status === 200) {
        setAddedEvents(addedEventsResponse.data);
      }

      const response = await axios.get(
        `${ApiConnectionString}/api/eventstoaccess?ClubId=${clubId}&ProductId=${productId}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (response.status === 200) {
        setEvents(response.data);
      }
    } catch (error) {
      console.error("Error fetching events:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, [clubId, productId, user.token]);

  const handleEventSelection = (e) => {
    setSelectedEvent(e.target.value);
  };

  const handleAddEvent = async (e) => {
    e.preventDefault();
    const createProductAccess = {
      productId: productId,
      eventId: selectedEvent,
    };

    try {
      await axios.post(
        `${ApiConnectionString}/api/productaccess`,
        createProductAccess,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      // Fetch events again after adding a new event
      await fetchEvents();
    } catch (error) {
      console.error("Error adding event:", error);
    }
    setSelectedEvent("")
  };
  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
        </div>
      </div>
    );
  } else {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <div className="blueBanner">
            <p className="fw-bold m-2 p-2 fontSize20">Product Access</p>
          </div>

          <button
            type="button"
            className="close-button"
            onClick={cancelModal}
            aria-label="Close"
          >
            &times;
          </button>
          <form>
            <div className="form-group">
              <label htmlFor="eventSelect">Select Event:</label>
              <select
                id="eventSelect"
                className="form-control"
                value={selectedEvent}
                onChange={handleEventSelection}
              >
                <option value="" disabled>
                  Select an event
                </option>
                {events.map((event) => (
                  <option key={event.id} value={event.id}>
                    {event.name}{" "}
                    {!event.oneOff
                      ? event.day
                      : event.oneOffDate.substring(0, 10)}{" "}
                    {event.timeIn} - {event.timeOut}
                  </option>
                ))}
              </select>

              <button
                onClick={handleAddEvent}
                disabled={!selectedEvent}
                className="profile-blue-button mb-2"
              >
                <Plus className="profile-social-icon" />{" "}
                <a className="fw-bold mx-2 mt-1">Add Event</a>
              </button>
            </div>
          </form>
          <div className="lightBlueBanner">
            <p className="p-2">Current Accesses</p>
          </div>

          <table className="custom-table">
            <thead className="blueBanner">
              <tr>
                <th>Class</th>
                <th>Day</th>
                <th>Times</th>
              </tr>
            </thead>
            <tbody>
              {addedEvents.map((addedEvent, index) => (
                <>
                  <tr key={index}>
                    <td>{addedEvent.name}</td>
                    {!addedEvent.oneOff ? (
                      <td>{addedEvent.day}</td>
                    ) : (
                      <td>{addedEvent.oneOffDate.substring(0, 10)}</td>
                    )}
                    <td>
                      {addedEvent.timeIn} - {addedEvent.timeOut}
                    </td>
                    <td>
                      <button
                        onClick={() => {
                          handleRemove(addedEvent);
                        }}
                        className="profile-blue-button mb-2"
                      >
                        <Trash className="profile-social-icon" />{" "}
                      </button>
                    </td>
                  </tr>
                </>
              ))}
            </tbody>
          </table>

          <div></div>
          <div className="send-modal-footer">
            <button
              onClick={cancelModal}
              className="pointer cancelButton fw-bold mx-2 px-3"
            >
             Close
            </button>
          </div>
        </div>
      </div>
    );
  }
}
